export enum ItemTypeMetadata {

    Button = "BUTTON_ITEM",
    Text = "TEXT_ITEM",
    Numeric = "NUMERIC_ITEM",
    Radio = "RADIO_ITEM",
    TextArea = "TEXTAREA_ITEM",
    Select = "SELECT_ITEM",
    CheckBox = "CHECKBOX_ITEM",
    MultiCheckBox = "MULTI_CHECKBOX_ITEM",
    Datepicker = "DATEPICKER_ITEM",
    Html = "HTML_ITEM",
    Time = "TIME_ITEM",
    Custom = "CUSTOM_ITEM"

}

export const ITEM_TYPES_METADATA: ItemTypeMetadata[] = [
    ItemTypeMetadata.Button,
    ItemTypeMetadata.Numeric,
    ItemTypeMetadata.Text,
    ItemTypeMetadata.Radio,
    ItemTypeMetadata.TextArea,
    ItemTypeMetadata.Select,
    ItemTypeMetadata.CheckBox,
    ItemTypeMetadata.MultiCheckBox,
    ItemTypeMetadata.Datepicker,
    ItemTypeMetadata.Html,
    ItemTypeMetadata.Time,
    ItemTypeMetadata.Custom
]

export function ToItemTypeMetadata(type: string): ItemTypeMetadata | null {
    switch (type) {
        case "BUTTON_ITEM":
            return ItemTypeMetadata.Button
        case "TEXT_ITEM":
            return ItemTypeMetadata.Text
        case "NUMERIC_ITEM":
            return ItemTypeMetadata.Numeric
        case "RADIO_ITEM":
            return ItemTypeMetadata.Radio
        case "TEXTAREA_ITEM":
            return ItemTypeMetadata.TextArea
        case "SELECT_ITEM":
            return ItemTypeMetadata.Select
        case "MULTI_CHECKBOX_ITEM":
            return ItemTypeMetadata.MultiCheckBox
        case "CHECKBOX_ITEM":
            return ItemTypeMetadata.CheckBox
        case "DATEPICKER_ITEM":
            return ItemTypeMetadata.Datepicker
        case "HTML_ITEM":
            return ItemTypeMetadata.Html
        case "TIME_ITEM":
            return ItemTypeMetadata.Time
        case "CUSTOM_ITEM":
            return ItemTypeMetadata.Custom
    }
    return null
}

export function itemTypeMetadataToIcon(itemType: ItemTypeMetadata): string {
    switch (itemType) {
        case ItemTypeMetadata.Button:
            return "smart_button"
        case ItemTypeMetadata.Numeric:
            return "123"
        case ItemTypeMetadata.Text:
            return "format_color_text"
        case ItemTypeMetadata.CheckBox:
            return "check_box"
        case ItemTypeMetadata.MultiCheckBox:
            return "fact_check"
        case ItemTypeMetadata.Custom:
            return "question_mark"
        case ItemTypeMetadata.Datepicker:
            return "event"
        case ItemTypeMetadata.Html:
            return "html"
        case ItemTypeMetadata.Time:
            return "schedule"
        case ItemTypeMetadata.Radio:
            return "radio_button_checked"
        case ItemTypeMetadata.Select:
            return "arrow_drop_down_circle"
        case ItemTypeMetadata.TextArea:
            return "format_align_left"

    }
    return "text_fields"
}

export function itemTypeMetadataToName(itemType: ItemTypeMetadata): string {
    switch (itemType) {
        case ItemTypeMetadata.Button:
            return "Butó"
        case ItemTypeMetadata.Text:
            return "Text"
        case ItemTypeMetadata.Numeric:
            return "Número"
        case ItemTypeMetadata.CheckBox:
            return "Checkbox"
        case ItemTypeMetadata.MultiCheckBox:
            return "MultiCheckbox"
        case ItemTypeMetadata.Custom:
            return "Custom"
        case ItemTypeMetadata.Datepicker:
            return "Calendari"
        case ItemTypeMetadata.Html:
            return "Html"
        case ItemTypeMetadata.Time:
            return "Hora i Minuts"
        case ItemTypeMetadata.Radio:
            return "Radiobutton"
        case ItemTypeMetadata.Select:
            return "Select"
        case ItemTypeMetadata.TextArea:
            return "Paràgraf"

    }
}